import React, { useEffect } from 'react';

export const Dashboard = ({
  dailyVerse,
  setCurrentView,
  currentUser,
  selectedDate,
  loadDashboard,
  attendanceData,
  setActiveTab,
  generateBackup,
  backupLoading,
  restoreLoading,
  handleRestoreFile,
  turmas,
  students,
  handleLogout,
  getFilteredTurmas,
  igrejaAtual,
  setNeedsIgrejaSelection,
  planoInfo,
  onShowPlanos
}) => {
  // Se for super_admin, redirecionar para painel SaaS
  useEffect(() => {
    if (currentUser?.tipo === 'super_admin') {
      setCurrentView('gerenciar-igrejas');
    }
  }, [currentUser?.tipo, setCurrentView]);

  // Se for super_admin, mostrar mensagem enquanto redireciona
  if (currentUser?.tipo === 'super_admin') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="bg-white rounded-lg shadow-xl p-8 max-w-md text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Redirecionando para Painel SaaS...</p>
        </div>
      </div>
    );
  }

  return (
  <div className="bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
    <div className="max-w-7xl mx-auto">
      {/* Banner Minimalista com Versículo Bíblico */}
      <div className="bg-gradient-to-r from-indigo-900 via-blue-800 to-indigo-900 text-white px-6 py-4 shadow-lg">



        <div className="flex justify-between items-center">
          <button
            onClick={() => setCurrentView('home')}
            className="px-3 py-2 bg-white bg-opacity-20 text-white rounded-lg hover:bg-opacity-30 transition-all duration-200 text-sm"
          >
            ← Início
          </button>

          {/* Logo e Título Minimalista */}
          <div className="flex items-center space-x-3">
            {/* Logo da Igreja (se existir) ou ícone padrão */}
            {igrejaAtual?.logo_url ? (
              <div className="w-14 h-14 bg-white rounded-full overflow-hidden shadow-lg flex-shrink-0">
                <img src={igrejaAtual.logo_url} alt={igrejaAtual.nome} className="w-full h-full object-cover" />
              </div>
            ) : (
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg flex-shrink-0">
                <span className="text-3xl">📖</span>
              </div>
            )}
            <div className="text-center">
              <h1 className="text-2xl font-bold tracking-wide">App EBD - Escola Dominical</h1>
              {/* Versículo Bíblico Diário */}
              <div className="mt-1 text-sm text-blue-200 max-w-md">
                <p className="italic">"{dailyVerse.text}"</p>
                <p className="text-blue-300 text-xs mt-1 font-medium">{dailyVerse.reference}</p>
              </div>
            </div>
          </div>

          <div className="text-right">
            <div className="text-sm text-blue-200">
              <p>Logado como:</p>
              <p className="font-semibold text-white">{currentUser?.nome}</p>
              <p className="text-xs">({currentUser?.tipo === 'admin' ? 'Administrador' : currentUser?.tipo === 'moderador' ? 'Moderador' : currentUser?.tipo === 'professor' ? 'Professor' : currentUser?.tipo === 'visitante' ? 'Visitante' : 'Super Admin'})</p>
            </div>
            <button
              onClick={handleLogout}
              className="mt-2 px-3 py-1 bg-red-500 bg-opacity-80 text-white rounded hover:bg-opacity-100 transition-all duration-200 text-sm"
            >
              Sair
            </button>
          </div>
        </div>
      </div>

      {/* Header com Nome da Igreja (Multi-Tenancy) */}
      {igrejaAtual && igrejaAtual.id !== 'all' && (
        <div className="bg-blue-600 text-white px-6 py-4 shadow-md">
          <div className="flex flex-col items-center justify-center">
            {/* Nome da Igreja */}
            <div className="flex items-center space-x-3">
              <span className="font-bold text-xl">{igrejaAtual.nome}</span>
              {igrejaAtual.cnpj && (
                <span className="text-blue-200 text-sm">CNPJ: {igrejaAtual.cnpj}</span>
              )}
            </div>
            {/* Informações da Liderança */}
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-1 mt-2 text-sm text-blue-100">
              {igrejaAtual.presidente && (
                <span>👔 <strong>Presidente:</strong> {igrejaAtual.presidente}</span>
              )}
              {igrejaAtual.pastor && (
                <span>⛪ <strong>Pastor Local:</strong> {igrejaAtual.pastor}</span>
              )}
              {igrejaAtual.superintendente_ebd && (
                <span>📖 <strong>Sup. EBD:</strong> {igrejaAtual.superintendente_ebd}</span>
              )}
            </div>
            {/* Botão Trocar Igreja */}
            {currentUser?.igrejas?.length > 1 && (
              <button
                onClick={() => {
                  setNeedsIgrejaSelection(true);
                  setCurrentView('home');
                }}
                className="mt-3 px-4 py-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg transition-all duration-200 text-sm font-medium"
              >
                🔄 Trocar Igreja
              </button>
            )}
          </div>
        </div>
      )}

      <div className="p-6">
        {/* Resumo Rápido */}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-8 border border-gray-200">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="text-2xl font-bold text-gray-800">Resumo Rápido</h2>
              <p className="text-gray-600">Estatísticas do último domingo</p>
            </div>
            <div className="text-right">
              <p className="text-sm text-gray-500">Data: {selectedDate}</p>
              <button
                onClick={loadDashboard}
                className="mt-1 px-4 py-2 bg-gradient-to-r from-indigo-500 to-blue-600 text-white rounded-lg hover:from-indigo-600 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-lg transition-all duration-200 text-sm"
              >
                🔄 Atualizar
              </button>
            </div>
          </div>

          {/* Cards de Resumo */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4 text-center">
              <div className="text-2xl font-bold text-blue-600">
                {attendanceData.reduce((sum, row) => sum + row.matriculados, 0)}
              </div>
              <div className="text-sm text-blue-500 font-medium">Matriculados</div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-4 text-center">
              <div className="text-2xl font-bold text-green-600">
                {attendanceData.reduce((sum, row) => sum + row.presentes, 0)}
              </div>
              <div className="text-sm text-green-500 font-medium">Presentes</div>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-4 text-center">
              <div className="text-2xl font-bold text-purple-600">
                {(() => {
                  const totalMatriculados = attendanceData.reduce((sum, row) => sum + row.matriculados, 0);
                  const totalPresentes = attendanceData.reduce((sum, row) => sum + row.presentes, 0);
                  return totalMatriculados > 0 ? ((totalPresentes / totalMatriculados) * 100).toFixed(1).replace('.', ',') : '0,0';
                })()}%
              </div>
              <div className="text-sm text-purple-500 font-medium">Frequência</div>
            </div>

            <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-lg p-4 text-center">
              <div className="text-2xl font-bold text-yellow-600">
                R$ {attendanceData.reduce((sum, row) => sum + row.total_ofertas, 0).toFixed(2).replace('.', ',')}
              </div>
              <div className="text-sm text-yellow-500 font-medium">Ofertas</div>
            </div>
          </div>

          {/* Turmas com Melhor Frequência */}
          {attendanceData.length > 0 && (
            <div className="mt-6 pt-6 border-t border-gray-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-3">🏆 Destaques do Dia</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-green-50 rounded-lg p-4">
                  <div className="font-semibold text-green-800">Melhor Frequência</div>
                  <div className="text-green-700">
                    {(() => {
                      const melhorFrequencia = attendanceData
                        .filter(row => row.matriculados > 0)
                        .sort((a, b) => (b.presentes / b.matriculados) - (a.presentes / a.matriculados))[0];
                      return melhorFrequencia ?
                        `${melhorFrequencia.turma_nome} (${((melhorFrequencia.presentes / melhorFrequencia.matriculados) * 100).toFixed(1).replace('.', ',')}%)` :
                        'Nenhuma turma';
                    })()}
                  </div>
                </div>

                <div className="bg-yellow-50 rounded-lg p-4">
                  <div className="font-semibold text-yellow-800">Maior Oferta</div>
                  <div className="text-yellow-700">
                    {(() => {
                      const maiorOferta = attendanceData
                        .sort((a, b) => b.total_ofertas - a.total_ofertas)[0];
                      return maiorOferta ?
                        `${maiorOferta.turma_nome} (R$ ${maiorOferta.total_ofertas.toFixed(2).replace('.', ',')})` :
                        'Nenhuma turma';
                    })()}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Cards de Ações e Resumo */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Ações Rápidas */}
          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
            <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
              <span className="text-2xl mr-2">⚡</span>
              Ações Rápidas
            </h3>
            <div className="space-y-4">
              <button
                onClick={() => setCurrentView('chamada')}
                className="w-full px-6 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 focus:outline-none focus:ring-2 focus:ring-green-500 shadow-lg transition-all duration-200 flex items-center justify-center text-lg font-semibold"
              >
                <span className="text-xl mr-2">✅</span>
                Fazer Chamada
              </button>

              {(currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'professor' || currentUser?.tipo === 'superadmin' || currentUser?.tipo === 'visitante') && (
                <>
                  <button
                    onClick={() => setCurrentView('relatorios')}
                    className="w-full px-6 py-4 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-lg hover:from-indigo-600 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-lg transition-all duration-200 flex items-center justify-center text-lg font-semibold"
                  >
                    <span className="text-xl mr-2">📊</span>
                    Relatórios Detalhados
                  </button>
                  {/* Faturamento - Apenas Admin e Moderador */}
                  {(currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador') && (
                    <button
                      onClick={() => setCurrentView('historico')}
                      className="w-full px-6 py-4 bg-gradient-to-r from-green-500 to-teal-600 text-white rounded-lg hover:from-green-600 hover:to-teal-700 focus:outline-none focus:ring-2 focus:ring-green-500 shadow-lg transition-all duration-200 flex items-center justify-center text-lg font-semibold"
                    >
                      <span className="text-xl mr-2">💰</span>
                      Faturamento
                    </button>
                  )}
                  <button
                    onClick={() => {
                      setActiveTab('alunos');
                      setCurrentView('ranking');
                    }}
                    className="w-full px-6 py-4 bg-gradient-to-r from-yellow-500 to-orange-600 text-white rounded-lg hover:from-yellow-600 hover:to-orange-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 shadow-lg transition-all duration-200 flex items-center justify-center text-lg font-semibold"
                  >
                    <span className="text-xl mr-2">🏆</span>
                    Rankings
                  </button>
                  <button
                    onClick={() => setCurrentView('alunos')}
                    className="w-full px-6 py-4 bg-gradient-to-r from-blue-500 to-cyan-600 text-white rounded-lg hover:from-blue-600 hover:to-cyan-700 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-lg transition-all duration-200 flex items-center justify-center text-lg font-semibold"
                  >
                    <span className="text-xl mr-2">👥</span>
                    Gerenciar Alunos
                  </button>

                  <button
                    onClick={() => setCurrentView('turmas')}
                    className="w-full px-6 py-4 bg-gradient-to-r from-purple-500 to-pink-600 text-white rounded-lg hover:from-purple-600 hover:to-pink-700 focus:outline-none focus:ring-2 focus:ring-purple-500 shadow-lg transition-all duration-200 flex items-center justify-center text-lg font-semibold"
                  >
                    <span className="text-xl mr-2">🏫</span>
                    Gerenciar Turmas
                  </button>
                  {/* Gerenciar Usuários - Apenas Admin e Moderador */}
                  {(currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador') && (
                    <button
                      onClick={() => setCurrentView('usuarios')}
                      className="w-full px-6 py-4 bg-gradient-to-r from-red-500 to-pink-600 text-white rounded-lg hover:from-red-600 hover:to-pink-700 focus:outline-none focus:ring-2 focus:ring-red-500 shadow-lg transition-all duration-200 flex items-center justify-center text-lg font-semibold"
                    >
                      <span className="text-xl mr-2">🔐</span>
                      Gerenciar Usuários
                    </button>
                  )}

                  {/* Minha Conta - Admin */}
                  {(currentUser?.tipo === 'admin') && onShowPlanos && (
                    <button
                      onClick={onShowPlanos}
                      className="w-full px-6 py-4 bg-gradient-to-r from-emerald-500 to-teal-600 text-white rounded-lg hover:from-emerald-600 hover:to-teal-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 shadow-lg transition-all duration-200 flex items-center justify-center text-lg font-semibold"
                    >
                      <span className="text-xl mr-2">⭐</span>
                      Minha Conta
                    </button>
                  )}

                  {/* Painel SaaS - Apenas para super_admin */}
                  {currentUser?.tipo === 'super_admin' && (
                    <button
                      onClick={() => setCurrentView('gerenciar-igrejas')}
                      className="w-full px-6 py-4 bg-gradient-to-r from-amber-500 to-orange-600 text-white rounded-lg hover:from-amber-600 hover:to-orange-700 focus:outline-none focus:ring-2 focus:ring-amber-500 shadow-lg transition-all duration-200 flex items-center justify-center text-lg font-semibold border-2 border-amber-300"
                    >
                      <span className="text-xl mr-2">🏛️</span>
                      Gerenciar Igrejas (Painel SaaS)
                    </button>
                  )}

                  {/* Seção de Backup e Restore - Apenas para Admin */}
                  {currentUser?.tipo === 'admin' && (
                    <div className="border-t pt-4 mt-4">
                      <h4 className="text-sm font-semibold text-gray-600 mb-3 flex items-center">
                        <span className="text-lg mr-1">💾</span>
                        Backup & Restore
                      </h4>

                      <div className="space-y-2">
                        {/* Botão Gerar Backup */}
                        <button
                          onClick={generateBackup}
                          disabled={backupLoading}
                          className="w-full px-4 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-md transition-all duration-200 flex items-center justify-center font-medium disabled:opacity-50"
                        >
                          {backupLoading ? (
                            <>
                              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                              Gerando...
                            </>
                          ) : (
                            <>
                              <span className="text-lg mr-2">⬇️</span>
                              Gerar Backup
                            </>
                          )}
                        </button>

                        {/* Botão Restaurar Backup */}
                        <div className="relative">
                          <input
                            type="file"
                            accept=".ebd,.json"
                            onChange={handleRestoreFile}
                            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                            id="restore-file-input"
                          />
                          <button
                            disabled={restoreLoading}
                            className="w-full px-4 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg hover:from-orange-600 hover:to-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 shadow-md transition-all duration-200 flex items-center justify-center font-medium disabled:opacity-50"
                          >
                            {restoreLoading ? (
                              <>
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                Restaurando...
                              </>
                            ) : (
                              <>
                                <span className="text-lg mr-2">⬆️</span>
                                Restaurar Backup
                              </>
                            )}
                          </button>
                        </div>

                        {/* Botão Lixeira - Dentro da seção de ferramentas admin */}
                        {(currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador') && (
                          <button
                            onClick={() => setCurrentView('lixeira')}
                            className="w-full px-4 py-3 bg-gradient-to-r from-gray-500 to-gray-700 text-white rounded-lg hover:from-gray-600 hover:to-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-md transition-all duration-200 flex items-center justify-center font-medium"
                          >
                            <span className="text-lg mr-2">🗑️</span>
                            Lixeira
                          </button>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Seção de Configurações - Admin/Moderador */}
                  {(currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'superadmin') && (
                    <div className="border-t pt-4 mt-4">
                      <h4 className="text-sm font-semibold text-gray-600 mb-3 flex items-center">
                        <span className="text-lg mr-1">⚙️</span>
                        Configurações
                      </h4>

                      <div className="space-y-2">
                        <button
                          onClick={() => setCurrentView('config-chamadas')}
                          className="w-full px-4 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-md transition-all duration-200 flex items-center justify-center font-medium"
                        >
                          <span className="text-lg mr-2">⏰</span>
                          Configurar Chamadas
                        </button>

                        <button
                          onClick={() => setCurrentView('config-departamentos')}
                          className="w-full px-4 py-3 bg-gradient-to-r from-purple-500 to-purple-600 text-white rounded-lg hover:from-purple-600 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 shadow-md transition-all duration-200 flex items-center justify-center font-medium"
                        >
                          <span className="text-lg mr-2">🏆</span>
                          Configurar Departamentos
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* Botão Alterar Senha - visível para todos */}
              <button
                onClick={() => setCurrentView('alterar-senha')}
                className="w-full px-6 py-4 bg-gradient-to-r from-gray-500 to-gray-600 text-white rounded-lg hover:from-gray-600 hover:to-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-lg transition-all duration-200 flex items-center justify-center text-lg font-semibold"
              >
                <span className="text-xl mr-2">🔒</span>
                Alterar Senha
              </button>

              <button
                onClick={() => setCurrentView('revistas')}
                className="w-full px-6 py-4 bg-gradient-to-r from-teal-500 to-green-600 text-white rounded-lg hover:from-teal-600 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-teal-500 shadow-lg transition-all duration-200 flex items-center justify-center text-lg font-semibold"
              >
                <span className="text-xl mr-2">📖</span>
                Revistas Trimestrais
              </button>

              {currentUser?.tipo === 'professor' && (
                <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                  <p className="text-sm text-blue-700">
                    <strong>Suas turmas:</strong>
                  </p>
                  <div className="mt-2 space-y-1">
                    {getFilteredTurmas().map(turma => (
                      <span key={turma.id} className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mr-1">
                        {turma.nome}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Resumo Estatístico */}
          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
            <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
              <span className="text-2xl mr-2">📈</span>
              Resumo Geral
            </h3>
            <div className="space-y-4">
              <div className="flex justify-between items-center p-3 bg-blue-50 rounded-lg">
                <span className="text-gray-700 font-medium">Total de Turmas:</span>
                <span className="text-2xl font-bold text-blue-600">{turmas.length}</span>
              </div>
              <div className="flex justify-between items-center p-3 bg-green-50 rounded-lg">
                <span className="text-gray-700 font-medium">Total de Alunos:</span>
                <span className="text-2xl font-bold text-green-600">{students.length}</span>
              </div>
              <div className="flex justify-between items-center p-3 bg-emerald-50 rounded-lg">
                <span className="text-gray-700 font-medium">Presentes Hoje:</span>
                <span className="text-2xl font-bold text-emerald-600">
                  {attendanceData.reduce((sum, row) => sum + row.presentes, 0)}
                </span>
              </div>
              <div className="flex justify-between items-center p-3 bg-yellow-50 rounded-lg">
                <span className="text-gray-700 font-medium">Ofertas Hoje:</span>
                <span className="text-xl font-bold text-yellow-600">
                  R$ {attendanceData.reduce((sum, row) => sum + row.total_ofertas, 0).toFixed(2).replace('.', ',')}
                </span>
              </div>
            </div>
          </div>

          {/* Dicas e Informações */}
          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
            <h3 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
              <span className="text-2xl mr-2">💡</span>
              Dicas de Uso
            </h3>
            <div className="space-y-3 text-sm text-gray-600">
              <div className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <p>A chamada só pode ser feita aos domingos</p>
              </div>
              <div className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <p>Use a tela de chamada para registrar presença e ofertas</p>
              </div>
              <div className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <p>O relatório é atualizado automaticamente após salvar</p>
              </div>
              <div className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <p>Use os relatórios detalhados para ver classes vencedoras</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Rodapé com Código da Igreja */}
      {igrejaAtual && igrejaAtual.id !== 'all' && (
        <div className="bg-gray-800 text-gray-400 px-6 py-3 mt-8">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-sm">
            <div className="flex items-center space-x-2">
              <span>🏛️</span>
              <span className="font-medium text-gray-300">{igrejaAtual.nome}</span>
            </div>
            <div className="flex items-center space-x-3 mt-2 sm:mt-0">
              <span className="text-gray-500">Código da Igreja:</span>
              <span className="inline-flex items-center justify-center w-8 h-8 bg-blue-600 rounded-full">
                <span className="text-white font-bold">{igrejaAtual.codigo || '?'}</span>
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
  );
};
